<template>
  <v-layout justify-center fill-height row>
    <v-flex xs12>
      <v-card>
        <v-layout row wrap>
          <v-flex xs12 ms12>
            <v-card-title dense primary-title class="headline primary">
              <v-layout row align-center>
                <v-btn dark icon @click="$router.push('/settings/loyalty_rewards/')">
                  <v-icon>arrow_back</v-icon>
                </v-btn>
                <span
                  class="title font-weight-light white--text"
                >Create {{ external ? "External" : "Internal" }} Reward</span>
              </v-layout>
            </v-card-title>
          </v-flex>
          <v-flex xs12 md12 px-2 pt-2>
            <LoyaltyRewardForm
              :loyaltyReward="loyaltyReward"
              @validityChange="updateLoyaltyRewardFormValidity($event)"
              @imageInput="handleImageInput"
            ></LoyaltyRewardForm>
          </v-flex>
          <v-flex xs12 md12 v-if="!external">
            <PromotionForm
              ref="PromotionForm"
              :disabled="false"
              :promotion="loyaltyReward.promotion"
              :errors="errors"
              @validityChange="updateFormValidity($event)"
            />
            <v-divider class="mx-1"></v-divider>
          </v-flex>
          <v-flex xs12 md12 v-if="external">
            <ExternalPromotionForm
              ref="ExternalPromotionForm"
              :disabled="false"
              :promotion="loyaltyReward.external_promotion"
              :errors="errors"
              @validityChange="updateFormValidity($event)"
            />
            <v-divider class="mx-1"></v-divider>
          </v-flex>
          <v-flex xs12 md12 pt-2 pb-2>
            <v-layout align-center justify-end row>
              <v-btn color="success" @click="submit" class="text-none">Submit</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </v-layout>
</template>

<script>
import PromotionForm from "@/components/settings/promotions/PromotionForm.vue";
import LoyaltyRewardForm from "@/components/settings/loyalty/LoyaltyRewardForm.vue";
import ExternalPromotionForm from "@/components/settings/loyalty/ExternalPromotionForm.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "create_loyalty_reward",
  components: {
    PromotionForm,
    ExternalPromotionForm,
    LoyaltyRewardForm
  },
  computed: {
    external: function() {
      console.log("Query " + this.$route.query.external);
      return this.$route.query.external == "true";
    }
  },
  data: function() {
    return {
      loyaltyReward: {
        minimum_tier_id: 1,
        maximum_tier_id: 1,
        cost: 0,
        enabled: true,
        image: {},
        promotion: {
          name: "",
          description: "",
          user_description: "", //Description for the customer?
          start_date: "2019-01-01 00:00",
          end_date: "2029-01-01 00:00",
          code_lifespan_days: "",
          discount_type: "percentage", //fixed_amount or percentage
          discount_percentage: "", //Required if percentage
          discount_fixed: "", //Required if fixed - in pounds
          max_booking_cost_with_discount: "", //In pounds - for both discount types?
          cost_absorbed_by: "company", //company or driver
          allow_multiple_entries: true,
          codes: [],
          enabled: true
        },
        external_promotion: {
          name: "",
          description: "",
          user_description: "", //Description for the customer?
          start_date: "",
          end_date: "",
          expiry_time_minutes: 15,
          code: "",
          enabled: true,
          category: "External"
        }
      },
      errors: {},
      promotionFormValid: false,
      loyaltyRewardFormValid: true,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null
    };
  },
  methods: {
    submit: async function() {
      console.log(this.promotionFormValid);
      console.log(this.loyaltyRewardFormValid);
      if (this.promotionFormValid && this.loyaltyRewardFormValid) {
        let self = this;
        let url = `${this.$store.state.apiUrl}/settings/loyalty_point_reward/create`;

        var data = Object.assign({}, this.loyaltyReward);

        if (!this.external) {
          let promotionToSend = Object.assign({}, this.loyaltyReward.promotion);
          let codesToSend = [];
          promotionToSend.codes.forEach(function(promocode) {
            codesToSend.push(promocode.code);
          });
          promotionToSend.codes = codesToSend;

          data.promotion = promotionToSend;
        }

        console.log(data);

        if (this.external) {
          delete data.promotion;
        } else {
          delete data.external_promotion;
        }

        if (data.image.data == null) {
          delete data.image;
        }

        axios({
          url: url,
          method: "post",
          data: { loyalty_point_reward: data },
          headers: {
            "Content-Type": "text/plain"
          }
        })
          .then(function(response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.snackbarMessage =
                "Error adding reward, please check the form";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            } else if (response.data.error != "no_error") {
              self.snackbarMessage =
                "Error adding reward: " + response.data.error;
              self.snackbarColour = "error";
              self.snackbarShow = true;
              console.log(response.data.error);
            } else {
              self.$router.push("/settings/loyalty_rewards/");
            }
          })
          .catch(function(error) {
            console.log(error);
            self.snackbarMessage = "Network error: " + error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.PromotionForm.validateForm();
      }
    },
    handleImageInput: function(file) {
      this.loyaltyReward.image = file;
    },
    updateFormValidity: function(value) {
      this.promotionFormValid = value;
    },
    updateLoyaltyRewardFormValidity: function(value) {
      this.loyaltyRewardFormValid = value;
    }
  }
};
</script>